"use client";

import { CookieConsentButton } from "@/components/common/CookieConsentButton";
import dynamic from "next/dynamic";

const CookieManager = dynamic(
    () => import("react-cookie-manager").then((mod) => mod.CookieManager),
    { ssr: false, loading: () => null }
);

// In your Providers component or layout
export function CookieManagerProvider({ children }: { children: React.ReactNode }) {

    const environment = process.env.NODE_ENV;

    return (
        <CookieManager
            showManageButton={true}
            translations={{
                title: "Cookie Preferences",
                message: "We use cookies to improve your experience.",
            }}
            displayType="banner"
            position="bottom"
            theme="dark" >
            {children}
            {environment !== 'production' ? null : <CookieConsentButton />}
        </CookieManager>
    );
}

// // In your page component
// import { useCookieConsent } from "react-cookie-manager";

// export default function Home() {
//     const { showConsentBanner, detailedConsent } = useCookieConsent();

//     return (
//         <div>
//             <button onClick={showConsentBanner}>Manage Cookie Settings</button>
//             {detailedConsent && (
//                 <div>
//                     Analytics:{" "}
//                     {detailedConsent.Analytics.consented ? "Enabled" : "Disabled"}
//                     Social: {detailedConsent.Social.consented ? "Enabled" : "Disabled"}
//                     Advertising:{" "}
//                     {detailedConsent.Advertising.consented ? "Enabled" : "Disabled"}
//                 </div>
//             )}
//         </div>
//     );
// }